import { render } from "./filesblock.vue?vue&type=template&id=4a34c15c"
import script from "./filesblock.vue?vue&type=script&lang=js"
export * from "./filesblock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__